import { parsePhoneNumber } from 'libphonenumber-js'
import { required, email } from 'vuelidate/lib/validators'

export const phoneNumber = phone => {
  try {
    return !!parsePhoneNumber(phone)
  } catch (error) {
    return false
  }
}

export const rules = {
  required: val => required(val) || 'Required',
  email: val => email(val) || 'Invalid e-mail',
  phone: val => phoneNumber(val) || 'Invalid number'
}
